/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { observer } from "mobx-react";
import {
  createStyles,
  Flex,
  Text,
  Progress,
  Button,
  SegmentedControl,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useStore } from "../../../hooks/use-store";
import { useRequest } from "ahooks";
import ImageObserved from "./Image";
import { NOTIFICATION_SERVICE } from "../../../components/notifications/NotificationService";


export type GalleryItem = {
  images: { url: string, preview: string }[];
  previewHdrl: string;
  enhancedHdrlFile: string;
  modelVersion?: string;
  loraPath?: string;
}

export type PrivateModel = {
  version: string;
  status: string;
  name: string;
  data: {
    images: { url: string, preview: string }[];
    name: string;
  };
}

const useStyles = createStyles((theme) => ({

  cardItem: {
    cursor: "pointer",
  },

  card: {
    border: '1px solid rgba(70, 70, 70, 1)'
  },

  cardTitle: {
    fontWeight: 700,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    lineHeight: 1.2,
  },

  body: {
    padding: theme.spacing.md,
    background: 'rgba(16, 16, 16, 1)',
  },

  wrapper: {
    maxWidth: "100%",
    width: "100%",
    padding: '0',
  },

  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '18px',
    width: '100%',
  },

  title: {
    marginBottom: theme.spacing.sm,
    paddingLeft: theme.spacing.sm,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
  },

  item: {
    fontSize: theme.fontSizes.sm,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[1]
        : theme.colors.gray[7],
  },

  center: {
    display: "flex",
    justifyContent: "center",
  },
  video: {
    margin: "0 auto",

    "> div": {
      position: "absolute!important" as any,
      transformOrigin: "left top",
      borderRadius: "8px",
      overflow: "hidden",
    },
  },
}));

const Element = () => {

  const {
    dataStore: { spaceStore },
    uiStore: { authStore },
  } = useStore();

  const { classes } = useStyles();
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const [selectedTab, setSelectedTab] = useState<string>('All');
  const history = useHistory();

  const {
    dataStore: { appStore },
  } = useStore();

  // List of demo locations to show for users without subscription
  const freeUserDemoLocations = [
    'ma-MAG_9459',
    'ma-MAG_14162',
    'ma-MAG_9162',
    'ma-MAG_10004',
    'ma-MAG_6576',

    // 'ma-MAG_9911',
    // 'ma-MAG_6287',
    // 'ma-MAG_8180',
    // 'ma-MAG_7117',
    // 'ma-MAG_13211'
  ];

  const { runAsync: fetchPrivateModels } = useRequest(
    async () =>
      appStore.fetchPrivateModels(),
    {
      loadingDelay: 20,
      manual: true,
      onSuccess: (model) => {
        spaceStore.setPrivateModels(model);
      },
    }
  );
  const { runAsync: fetchGallery } = useRequest(
    async () =>
      appStore.fetchGallery(),
    {
      loadingDelay: 20,
      manual: true,
      onSuccess: (model) => {
        spaceStore.setGallery(model);
      },
    }
  );

  useEffect(() => {
    async function fetchGalleryData() {
      const res = await fetchGallery();
      spaceStore.setGallery(res as any);
    }
    async function fetchPrivateModelsData() {
      const res = await fetchPrivateModels();
      spaceStore.setPrivateModels(res as any);
    }
    fetchGalleryData();
    fetchPrivateModelsData();
  }, [fetchGallery, fetchPrivateModels, spaceStore]);

  const eventHandlers = (id: string | undefined) => ({
    onMouseOver: () => setHoveredId(id || ''),
    onMouseOut: () => setHoveredId(null)
  });

  const TrainNewOneCard = () => (
    <Flex
      h="180px"
      w="100%"
      className={classes.cardItem}
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '4px',
        border: '2px solid #3f3f3f',
        // background: 'rgba(255, 133, 27, 0.1)',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '12px'
      }}
      onClick={() => {
        history.push('/gallery');
      }}
      {...eventHandlers('train-new')}
    >
      <Button
        style={{
          width: '38px',
          height: '38px',
          borderRadius: '8px',
          background: '#f53c02',
          border: 'none',
          fontSize: '24px',
          fontWeight: 'bold',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        +
      </Button>
      <Text color="white" size="sm" weight={600}>
        Search our location archive
      </Text>
    </Flex>
  );

  return (
    <Flex direction={'column'} w="100%" gap={8} mt={20} mb={60} className={classes.wrapper}>
      {/* My Locations Section */}
      {(selectedTab === 'All' || selectedTab === 'My') && (
        <>
          <Flex justify="space-between" align="center" mb={8}>
            <Text color="white" fw={700} fz={32}>
              My Trained AI Locations
            </Text>
            <SegmentedControl
              value={selectedTab}
              onChange={setSelectedTab}
              data={[
                { label: 'All', value: 'All' },
                { label: 'Demo', value: 'Demo' },
                { label: 'My', value: 'My' }
              ]}
              size="sm"
              color="orange"
              styles={{
                root: {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
                indicator: {
                  backgroundColor: '#f53c02',
                },
              }}
            />
          </Flex>
          <div className={classes.gridContainer}>
            <TrainNewOneCard />
            {spaceStore.privateModels && spaceStore.privateModels
              .slice()
              .sort((itm1, itm2) => {
                const realVersionId1 = itm1.record_id > 100000 ? 1 : itm1.record_id;
                const realVersionId2 = itm2.record_id > 100000 ? 1 : itm2.record_id;
                if (realVersionId2 === realVersionId1) {
                  return 0
                } else if (realVersionId1 < realVersionId2) {
                  return 1
                } else {
                  return -1
                }
              })
              .map((item, index) => (
                <Flex direction={'column'} key={item.version}>
                  <Flex
                    h="180px"
                    w="100%"
                    className={classes.cardItem}
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '4px'
                    }}
                    onClick={async () => {
                      if (item.status !== 'completed') {
                        NOTIFICATION_SERVICE.errorNotification(
                          "Location training is still in progress. Please wait until it completes."
                        );
                      } else {
                        spaceStore.setSelectedModel({
                          model: {
                            images: item.data.images.map((itm: { url: string, preview: string }) => itm.url),
                            mainImage: item.data.images[0].url,
                            name: item.data.name,
                            modelVersion: item.version,
                            status: 'competed',
                          }
                        })
                      }
                    }}
                    {...eventHandlers(item.version)}
                  >
                    <ImageObserved
                      width="100%"
                      height="240px"
                      src={item.data.images[0].preview}
                      objectFit="cover"
                      style={{
                        objectPosition: 'center',
                        borderRadius: '4px'
                      }}
                    />

                    {
                      (item.status === 'completed') ? <Button
                        w={'200px'}
                        style={{
                          zIndex: 10,
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          opacity: hoveredId === (item.version || '') ? 1 : 0,
                          transition: 'opacity 0.2s ease',
                        }}
                        variant="filled"
                        color="orange"
                        fz={12}
                        size="sm"
                        data-intercom-target={
                          'GetStartedWithThisLocation'
                        }
                      >
                        Get started with this location
                      </Button> : null
                    }


                    {(item.status !== 'completed') && (
                      <Flex
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'rgba(0, 0, 0, 0.7)',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '16px',
                        }}
                      >
                        <Text color="white" size="sm" weight={600} align="center" mb={8}>
                          LOCATION TRAIN IN PROGRESS
                        </Text>
                        <Progress
                          striped animate={true}
                          color={'orange'}
                          value={100}
                          size="sm"
                          radius="xl"
                          style={{ width: '80%' }}
                        />
                      </Flex>
                    )}
                    <Flex
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: '16px',
                        background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)',
                        opacity: hoveredId === (item.version || '') ? 1 : 0,
                        transition: 'opacity 0.2s ease',
                        height: '50%',
                        alignItems: 'flex-end'
                      }}
                    >
                      <Flex direction="column" gap={4}>
                        <Text color="white" size="sm" weight={600} style={{ textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
                          {item.data.name}
                        </Text>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              ))}
          </div>
        </>
      )}

      {/* Demo Locations Section */}
      {(selectedTab === 'All' || selectedTab === 'Demo') && (
        <>
          <Flex justify="space-between" align="center" mb={8} mt={selectedTab === 'All' ? 20 : 0}>
            <Text color="white" fw={700} fz={32}>
            Demo AI Locations
            </Text>
            {selectedTab === 'Demo' && (
              <SegmentedControl
                value={selectedTab}
                onChange={setSelectedTab}
                data={[
                  { label: 'All', value: 'All' },
                  { label: 'Demo', value: 'Demo' },
                  { label: 'My', value: 'My' }
                ]}
                size="sm"
                color="orange"
                styles={{
                  root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                  indicator: {
                    backgroundColor: '#f53c02',
                  },
                }}
              />
            )}
          </Flex>
          <div className={classes.gridContainer}>
            {selectedTab === 'Demo' && <TrainNewOneCard />}
            {spaceStore.gallery
              .filter(item => {
                // If user has subscription_id, show all demo locations
                if (authStore.currentUser?.id === 'user_ncW1SxIG5X3mwQGtmPp5Z' || authStore.currentUser?.id === 'user_RzgcIMD1nu3VgXxx1ohCx') {
                  return true;
                }
                // If user doesn't have subscription_id, only show specific demo locations
                const locationName = item.loraPath?.replace('.safetensors', '') || '';
                return freeUserDemoLocations.includes(locationName);
              })
              .map((item, index) => (
                <Flex
                  key={item.modelVersion}
                  h="180px"
                  w="100%"
                  className={classes.cardItem}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '4px'
                  }}
                  data-intercom-target={index === 0 ? 'FirstDemoLocation' : null
                  }
                  onClick={async () => {
                    console.log(item)
                    spaceStore.setSelectedModel({
                      model: {
                        images: item.images.map((itm: { url: string, preview: string }) => itm.url),
                        name: item.loraPath!.replace('.safetensors', ''),
                        mainImage: item.images[0].url,
                        modelVersion: item.modelVersion,
                        status: 'competed',
                      }
                    })
                  }}
                  {...eventHandlers(item.modelVersion)}
                >
                  <ImageObserved
                    width="100%"
                    height="240px"
                    src={item.images[0].preview}
                    objectFit="cover"
                    style={{
                      objectPosition: 'center',
                      borderRadius: '4px'
                    }}
                  />

                  <Button
                    w={'200px'}
                    style={{
                      zIndex: 10,
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      opacity: hoveredId === item.modelVersion ? 1 : 0,
                      transition: 'opacity 0.2s ease',
                    }}
                    variant="filled"
                    color="orange"
                    fz={12}
                    size="sm"
                    data-intercom-target={
                      'GetStartedWithThisLocation'
                    }
                  >
                    Get started with this location
                  </Button>
                  <Flex
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      padding: '16px',
                      background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)',
                      opacity: hoveredId === item.modelVersion ? 1 : 0,
                      transition: 'opacity 0.2s ease',
                      height: '50%',
                      alignItems: 'flex-end'
                    }}
                  >
                    <Flex direction="column" gap={4}>
                      <Text color="white" size="sm" weight={600} style={{ textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
                        {item.loraPath ? item.loraPath.replace('.safetensors', '') : 'Custom'}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              ))}
          </div>
        </>
      )}
    </Flex>
  )
};

export const Models = observer(Element);